import { Route, Switch, useRouteMatch } from "react-router-dom";
import SignUpLanding from "./components/SignUpLanding/SignUpLanding";
import { Provider } from "react-wrap-balancer";

// eslint-disable-next-line import/no-unresolved
import "!style-loader!css-loader!react-toastify/dist/ReactToastify.css";

// eslint-disable-next-line import/no-unresolved
import "!style-loader!css-loader!@pushpress/shared-components/build/main.min.css";

const SignUpRouter = () => {
  // This *can* match on the root route, since the sign up flow
  // is only rendered for the `signup.` subdomain.
  // Same goes for local development. You will need to add signup.pushpresslocal.com
  // to your /etc/hosts file to test locally
  const { path } = useRouteMatch("/");

  return (
    <Provider>
      <Switch>
        <Route path={`${path}`} component={SignUpLanding} />
      </Switch>
    </Provider>
  );
};

export default SignUpRouter;
